import React from 'react';
import { isBrowser } from '@firsttable/functions';
import { useRouter } from 'next/router';

const withLocation = (ComponentToWrap) => {
  const WithLocationComponent = (props) => {
    const router = useRouter();
    const location = isBrowser ? window.location : { pathname: '' };
    return (
      <ComponentToWrap
        {...props}
        search={router?.query}
        query={router?.query}
        location={location}
      />
    );
  };
  WithLocationComponent.displayName = 'withLocationComponent';
  return WithLocationComponent;
};

export default withLocation;
